import {all, call, put, takeLatest} from 'redux-saga/effects';

import {
    GET_WEBLAB_START,
    getWeblabComplete, WeblabTreatmentAction,
} from "src/actions/WeblabAction";
import {getWeblabList, callWeblabTreatments} from "src/utils/WeblabClient";
import WeblabTreatment from "src/model/WeblabTreatment";


export function* getWeblabTreatments(action: WeblabTreatmentAction) {
    const weblabList = getWeblabList();

    try {
        // @ts-ignore
        const treatments = yield call(callWeblabTreatments);

        yield put(getWeblabComplete(treatments));
    } catch(error) {
        console.error('failed to get weblab treatments!', error);

        const weblabTreatments: WeblabTreatment[] = [];

        weblabList.forEach(weblab => {
            weblabTreatments.push({ weblabId: weblab.id, treatment: weblab.defaultTreatment});
        });

        yield put(getWeblabComplete(weblabTreatments));
    }
}

export default function* weblabTreatments() {
    yield takeLatest(GET_WEBLAB_START, getWeblabTreatments);
}